import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useContext, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { isFunction } from "../../utils/is-function";
import { Positioner } from "./Positioner";
import { PopoverContext } from "./PopoverContext";
import { theme } from "../../theme";
var MOUNT_TRANSITION_DURATION = 200;
var UNMOUNT_TRANSITION_DURATION = 125;
var DISTANCE = 4;
var transitionDuration = {
  enter: MOUNT_TRANSITION_DURATION,
  exit: UNMOUNT_TRANSITION_DURATION
};
var fadeUpCss = css(["opacity:0;transform:scale(0.97) translateY(0) translateX(0);transition-property:opacity,transform;transition-timing-function:cubic-bezier(0.4,0,0,1);transition-duration:", "ms;will-change:transform,opacity;&[data-state='entering'],&[data-state='entered']{opacity:1;visibility:visible;transform:scale(1);}&[data-state='exiting']{opacity:0;transform:scale(0.97) translateY(0) translateX(0);transition-duration:", "ms;}&[data-position*='bottom'][data-state='entering'],&[data-position*='bottom'][data-state='entered']{transform:scale(1) translateY(", "px);}&[data-position='bottom']{transform-origin:50% 0;}&[data-position='bottom-start']{transform-origin:0 0;}&[data-position='bottom-end']{transform-origin:100% 0;}&[data-position*='top'][data-state='entering'],&[data-position*='top'][data-state='entered']{transform:scale(1) translateY(-", "px);}&[data-position='top']{transform-origin:50% 100%;}&[data-position='top-start']{transform-origin:0 100%;}&[data-position='top-end']{transform-origin:100% 100%;}&[data-position*='right'][data-state='entering'],&[data-position*='right'][data-state='entered']{transform:scale(1) translateX(", "px);}&[data-position='right']{transform-origin:0 50%;}&[data-position='right-start']{transform-origin:0 0;}&[data-position='right-end']{transform-origin:0 100%;}&[data-position*='left'][data-state='entering'],&[data-position*='left'][data-state='entered']{transform:scale(1) translateX(-", "px);}&[data-position='left']{transform-origin:100% 50%;}&[data-position='left-start']{transform-origin:100% 0;}&[data-position='left-end']{transform-origin:100% 100%;}"], MOUNT_TRANSITION_DURATION, UNMOUNT_TRANSITION_DURATION, DISTANCE, DISTANCE, DISTANCE, DISTANCE);
var PopoverContainer = styled.div.withConfig({
  displayName: "PopoverContent__PopoverContainer",
  componentId: "vapor__sc-65mguh-0"
})(["position:relative;--popover-background:", ";background:", ";border:1px solid;border-color:", ";box-shadow:4px 4px 50px rgba(0,0,0,0.4);border-radius:", ";outline:none;", ";"], function (p) {
  return p.$color === 'neutral' ? theme.colors.palette.grey00 : theme.colors.palette.grey15;
}, function (p) {
  return p.$color === 'neutral' ? theme.colors.palette.grey00 : theme.colors.palette.grey15;
}, function (p) {
  return p.$color === 'neutral' ? theme.colors.palette.whiteA15 : theme.colors.palette.whiteA05;
}, theme.radii[8], fadeUpCss);
export var PopoverContent = React.forwardRef(function PopoverContent(_ref, ref) {
  var id = _ref.id,
      role = _ref.role,
      offset = _ref.offset,
      shouldUsePositioner = _ref.shouldUsePositioner,
      _ref$shouldUsePortal = _ref.shouldUsePortal,
      shouldUsePortal = _ref$shouldUsePortal === void 0 ? false : _ref$shouldUsePortal,
      target = _ref.target,
      placement = _ref.placement,
      isShowing = _ref.isShowing,
      children = _ref.children,
      anchorPosition = _ref.anchorPosition,
      zIndex = _ref.zIndex,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'secondary' : _ref$color,
      boundary = _ref.boundary,
      autoHide = _ref.autoHide,
      other = _objectWithoutProperties(_ref, ["id", "role", "offset", "shouldUsePositioner", "shouldUsePortal", "target", "placement", "isShowing", "children", "anchorPosition", "zIndex", "color", "boundary", "autoHide"]);

  var _useContext = useContext(PopoverContext),
      onRequestClose = _useContext.onRequestClose;

  var renderContent = useCallback(function (_ref2) {
    var state = _ref2.state,
        position = _ref2.position;
    return /*#__PURE__*/React.createElement(PopoverContainer, _extends({
      id: id,
      role: role,
      ref: ref,
      "data-position": position,
      "data-state": state,
      tabIndex: -1,
      $color: color
    }, other), isFunction(children) ? children({
      onRequestClose: onRequestClose
    }) : children);
  }, [children, color, id, onRequestClose, other, ref, role]);
  return /*#__PURE__*/React.createElement(Positioner, {
    isShowing: isShowing,
    target: anchorPosition || target,
    transitionDuration: transitionDuration,
    placement: placement,
    offset: offset,
    shouldUsePositioner: shouldUsePositioner,
    shouldUsePortal: shouldUsePortal,
    zIndex: zIndex,
    boundary: boundary,
    autoHide: autoHide
  }, renderContent);
});
export var testExports = {
  PopoverContainer: PopoverContainer
};